module.exports = __webpack_public_path__ + "static/FloatingFile-2-dark-8f1e01b2a9f1fffaae249035f212fa04.svg";